import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { OFFER_ANCHOR } from "../utils/checkout";
import { useLocalizedPrices } from "../hooks/useLocalizedPrices";
export function MobileStickyCta() {
  const [visible, setVisible] = useState(false);
  const {
    mainPrice
  } = useLocalizedPrices();
  useEffect(() => {
    const offer = document.getElementById("oferta");
    let offerInView = false;
    const update = () => setVisible(window.scrollY > 700 && !offerInView);
    const observer = new IntersectionObserver(([entry]) => {
      offerInView = entry.isIntersecting;
      update();
    });
    if (offer) observer.observe(offer);
    window.addEventListener("scroll", update, {
      passive: true
    });
    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", update);
    };
  }, []);
  return <AnimatePresence data-id="element-162" data-mp="158ofg6uc3nek">
      {visible && <motion.div initial={{
      y: "100%"
    }} animate={{
      y: 0
    }} exit={{
      y: "100%"
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-cream-50/10 bg-cocoa-950/95 px-4 pb-[max(env(safe-area-inset-bottom),12px)] pt-3 backdrop-blur sm:hidden" data-id="element-163" data-mp="155ae91xepk8p">
          <a href={OFFER_ANCHOR} className="flex w-full items-center justify-center gap-2 rounded-full bg-caramel-500 px-4 py-3.5 text-sm font-bold uppercase tracking-wide text-cocoa-950 active:scale-[0.98]" data-id="element-164" data-mp="1wedhr92cvpps">
            Ver oferta · {mainPrice}
            <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-165" data-mp="2k9q0hfpbskh8" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}